// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ANqWO","comment":"styles_comment__1d91r"};